import { Dashboard, DashboardModel } from '@ddv/models';

import { Workspace } from './workspace';

export function setWidgetExtraParamsFromDashboardDetails(dashboardDetails: Dashboard, workspace: Workspace): void {
    // many of these ?? checks are against types that do not say they can be null/undefined
    // the implication is that either they are unnecessary or our types are lies
    const dashboardModel: DashboardModel = new DashboardModel({
        abbreviation: dashboardDetails.abbreviation ?? '',
        widgets: dashboardDetails.widgets ?? [],
        dashboardPreference: dashboardDetails.dashboardPreference ?? {},
        description: dashboardDetails.description ?? '',
        name: dashboardDetails.name,
        privilege: dashboardDetails.privilege,
        version: dashboardDetails.version,
        isGlobal: dashboardDetails.isGlobal,
        updatedDate: dashboardDetails.updatedDate,
    });
    workspace.setExtraParameters(dashboardModel);
}
